import request from '@/utils/sap-request'

// 附件下载
export const downLoadFile = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/download_file',
    method: 'POST',
    data
  })
}

// 查询省份
export const apiGetRegion = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/region_ovs',
    method: 'POST',
    data
  })
}

// 查询城市
export const apiGetCity = data => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/city_ovs',
    method: 'POST',
    data
  })
}

// 查询街道
export const apiGetStreet = data => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/street_ovs',
    method: 'POST',
    data
  })
}

export const getArea = (code, type = 'region', mode) => {
  if (type === 'region') {
    return apiGetRegion({mode})
  } else if (type === 'city') {
    return apiGetCity({ REGION: code, mode })
  } else {
    return apiGetStreet({ CITY_CODE: code, mode })
  }
}

// 营销单元 和 基地
export const apiGetOrgOrBase = (sobid = '', value = '1', arg = {}) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_ctrbase',
    method: 'post',
    data: { sobid, value, ...arg }
  })
}

// 修改/新增/删除字典
export const apiDropvalueMod = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/dropvalue_mod',
    method: 'post',
    data
  })
}

// 获取SAP字典
export const apiGetDropvalue = (code, ranges = {}) => {
  const data = {
    object_id: [
      {
        sign: 'I',
        option: 'EQ',
        low: code,
        high: ''
      }
    ]
  }
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_dropvalue',
    method: 'post',
    data: Object.assign(data, ranges)
  })
}


// WEBPACK FOOTER //
// ./src/api/sap/common-sap.js